import { css, cx } from '@linaria/core';
import { breakpoints } from 'styles/utils';
import { inputStyles } from 'components/Input/Input.styles';
const textInputContainerStyle = "omponents__UploadArea__components__TextUploader__TextUploader_styles_ts-textInputContainerStyle-t1c8c4yw";
export const textInputContainerStyles = cx(textInputContainerStyle);
const textArea = "omponents__UploadArea__components__TextUploader__TextUploader_styles_ts-textArea-t2xkmod";
export const textAreaStyles = cx(inputStyles, 'fullWidth', textArea);
const errorTextStyle = "omponents__UploadArea__components__TextUploader__TextUploader_styles_ts-errorTextStyle-e1kdr3l3";
export const errorTextStyles = cx(errorTextStyle);
export const submitContainer = "omponents__UploadArea__components__TextUploader__TextUploader_styles_ts-submitContainer-s1wtepiq";

require("./TextUploader.styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./TextUploader.styles.ts");